import type {
  ChangeCustomerProductInput,
  CustomerProduct,
  CustomerProductResponse,
  GetNewPackageCostInfoResponse,
  NewPackCostInfoRes,
  NewPackCostInput,
  PaymentMethodEnum
} from "__generated__/graphql"

import type { ApiFormattedResponse } from "@models/api_formatted_response"
import type { GraphQLBody } from "@models/graphql_body"
import { mutate, query } from "@utils/graphql"
import getNewPackageCostInfo from "__generated__/queries/queries/getNewPackageCostInfo"
import changeCustomerProduct from "__generated__/queries/mutations/changeCustomerProduct"

export type AdminChangeCustomerProductInput = ChangeCustomerProductInput & {
  paymentMethod: PaymentMethodEnum
}

export async function accountGetNewPackageCostInfo(
  data: NewPackCostInput
): Promise<ApiFormattedResponse<NewPackCostInfoRes>> {
  const response = await query<
    {
      getNewPackageCostInfo?: GetNewPackageCostInfoResponse
    },
    GraphQLBody<NewPackCostInput>
  >({
    query: getNewPackageCostInfo,
    variables: {
      data
    }
  })
  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }

  return {
    isSuccess: true,
    data: response?.data?.getNewPackageCostInfo?.data
  }
}

export async function accountChangeCustomerProduct(
  data: AdminChangeCustomerProductInput
): Promise<ApiFormattedResponse<CustomerProduct>> {
  const response = await mutate<
    {
      changeCustomerProduct?: CustomerProductResponse
    },
    GraphQLBody<AdminChangeCustomerProductInput>
  >({
    mutation: changeCustomerProduct,
    variables: {
      data
    }
  })
  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }

  return {
    isSuccess: true,
    data: response?.data?.changeCustomerProduct?.data
  }
}
